<div class="space-y-4">
  <!-- TABS -->
  <div class="flex flex-wrap gap-2">
    <button
      type="button"
      (click)="setTab('document')"
      [ngClass]="activeTab === 'document' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'"
      class="px-4 py-2 rounded-lg"
    >
      {{ 'CREDIT_DOCUMENTS.DOCUMENT_TAB' | translate }}
    </button>

    <button
      type="button"
      (click)="setTab('attachments')"
      [ngClass]="activeTab === 'attachments' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'"
      class="px-4 py-2 rounded-lg"
    >
      {{ 'CREDIT_DOCUMENTS.ATTACHMENTS_TAB' | translate }}
    </button>
  </div>

  @if (crdtPrpslSeq) {
    <!-- inPopup: no Back button / View History link — the builder page has its own navigation. -->
    @if (activeTab === 'document') {
      <app-document
        [moduleSeq]="CREDIT_PROPOSAL_MODULE_SEQ"
        [entitySeq]="crdtPrpslSeq"
        [allowedDocSeqs]="DOCUMENT_TAB_DOC_SEQS"
        [visibleDocSeqs]="DOCUMENT_TAB_DOC_SEQS"
        [accept]="ANY_FILE_ACCEPT"
        [viewOnly]="!editable"
        [inPopup]="true"
        [showDownloadAction]="false"
        [showHistoryPopupAction]="true"
        [useFaDeleteIcon]="true"
        [hideUploadedDocTypes]="true"
        (documentsChange)="onDocumentsChange()"
      >
      </app-document>
    } @else {
      <app-document
        [moduleSeq]="CREDIT_PROPOSAL_MODULE_SEQ"
        [entitySeq]="crdtPrpslSeq"
        [allowedDocSeqs]="ATTACHMENTS_TAB_DOC_SEQS"
        [visibleDocSeqs]="ATTACHMENTS_TAB_DOC_SEQS"
        [accept]="ANY_FILE_ACCEPT"
        [viewOnly]="!editable"
        [inPopup]="true"
        [showDownloadAction]="false"
        [showHistoryPopupAction]="true"
        [useFaDeleteIcon]="true"
        [hideUploadedDocTypes]="true"
        (documentsChange)="onDocumentsChange()"
      >
      </app-document>
    }
  }
</div>
